import React from 'react';
import { FlattenSimpleInterpolation } from 'styled-components';
import ReactSelect, { Props as BaseProps } from 'react-select';
import { default as CSelect } from 'react-select/creatable';

import {
  SelectSC,
  selectUnderlineStyles,
} from '@hilbi/web-common/components/e-visits/select/select.styled';

type FilteredBaseProps = Omit<BaseProps, 'isMulti'>;

export interface SelectProps extends FilteredBaseProps {
  error?: boolean;
  prefix?: React.ReactNode;
  isMulti?: boolean;
  label?: string;
  customCss?: FlattenSimpleInterpolation;
}

const CreatableSelect = (
  { styles, style, label, alignment, customCss, ...rest }: SelectProps,
  ref?: React.Ref<ReactSelect>,
) => {
  const selectStyle = React.useMemo(() => selectUnderlineStyles(styles), ['lined', styles]);

  return (
    <SelectSC style={style as React.CSSProperties} variation={'lined'} customCss={customCss}>
      {rest.prefix && rest.prefix}
      <CSelect
        className="ui-select"
        classNamePrefix="ui-react-select"
        style={selectStyle}
        isClearable
        {...rest}
      />
    </SelectSC>
  );
};

export default CreatableSelect;
